import { DashboardTranslate } from './dashboardTranslate.model';

const dashboardTranslateEN: DashboardTranslate = {
  title: 'Overview',
  kpi: {
    eventsThisWeek: {
      label: 'Events this week',
      subtext: 'Next: {{name}}',
      empty: 'No events scheduled',
    },
    newLeadsThisMonth: {
      label: 'New leads this month',
      subtext: '{{delta}} vs previous month',
    },
    overdueTasks: {
      label: 'Overdue tasks',
      subtext: 'Tap to view',
    },
    overdueAmount: {
      label: 'Overdue',
      subtext_one: '{{count}} client to charge',
      subtext_other: '{{count}} clients to charge',
      empty: 'Nothing overdue',
    },
    dueTodayTasks: {
      label: 'Due today',
      subtext: 'Tap to view',
    },
  },
  widgets: {
    receivables: 'Collections',
    todos: 'Tasks',
    events: 'Upcoming events',
    leads: 'Recent clients',
    births: 'Expected births',
  },
  customize: {
    trigger: 'Customize',
    title: 'Visible widgets',
  },
  upcomingBirths: {
    title: 'Upcoming births',
    today: 'today',
    inDays: 'in {{count}} day(s)',
    overdueDays: '{{count}} day(s) overdue',
  },
};

export default dashboardTranslateEN;
